import { useTranslation } from 'react-i18next';
import { Bar } from 'recharts';
import { DateRange } from '../../../../components/dates/RangeCalendar';
import { WorkoutWithCycleAndSession } from '../../types';
import { ActualWorkout, PhaseSpan } from '../types';
import {
  ACTUAL_COLOR,
  BowlingDayChart,
  PLANNED_COLOR,
} from './BowlingDayChart';

export const BowlingSideBySideChart = (props: {
  actualWorkouts: ActualWorkout[];
  prescriptionWorkouts: WorkoutWithCycleAndSession[];
  phases: PhaseSpan[];
  dateRange: DateRange;
}) => {
  const { t } = useTranslation();
  return (
    <BowlingDayChart
      title={t('sideBySidePlannedVsActuals')}
      {...props}
      // Drop the unused actual series when there's no data — Recharts would
      // otherwise reserve a side-by-side slot for it, shifting the planned
      // bars off-center.
      renderBars={({ hasActual }) => (
        <>
          <Bar
            dataKey="planned"
            name={t('planned')}
            fill={PLANNED_COLOR}
            radius={[2, 2, 0, 0]}
            isAnimationActive={false}
          />
          {hasActual && (
            <Bar
              dataKey="actual"
              name={t('actuals')}
              fill={ACTUAL_COLOR}
              radius={[2, 2, 0, 0]}
              isAnimationActive={false}
            />
          )}
        </>
      )}
    />
  );
};
